module.exports = {
  id: 43,
  name: 'L-Sit Hold',
  categories: ['strength', 'core', 'arms', 'balance'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Strength',
  points: 24,
  instructions:
    'L-sit holds are challenging! Sit on the ground, lift your body up with your arms, and hold your legs straight out! ',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: "This builds incredible core and arm strength! Let's get strong champ!",
    },
    {
      time: 4,
      text: 'Sit on the ground, lift your body up with your arms, and hold your legs straight out! Hold this position for 45 seconds or as long as you can hold it!',
    },
    // SET 1 - 45 seconds
    {
      time: 8,
      text: 'If you need to rest, drop you feet down and when you are ready, lift your body up with your arms again!',
    },
    {
      time: 13,
      text: ' Keep trying! The longer you can hold yourself up, the stronger you will get!',
    },
    {
      time: 15,
      text: 'Hold your legs straight out in front of you!',
    },
    {
      time: 17,
      text: 'Keep your core engaged and stay strong!',
    },
    {
      time: 19,
      text: 'Push through your arms, you are doing great!',
    },
    {
      time: 21,
      text: 'Hold your L-sit position, keep breathing!',
    },
    {
      time: 23,
      text: 'Keep your legs straight and your body lifted!',
    },
    {
      time: 25,
      text: 'You are building incredible arm strength!',
    },
    {
      time: 27,
      text: 'Hold your position, stay focused!',
    },
    {
      time: 29,
      text: 'Keep your core tight and your legs straight!',
    },
    {
      time: 31,
      text: 'You are doing amazing, keep going!',
    },
    {
      time: 33,
      text: 'Hold your L-sit, you are getting stronger!',
    },
    {
      time: 35,
      text: 'Keep pushing through your arms!',
    },
    {
      time: 37,
      text: 'Stay in position, you are incredible!',
    },
    {
      time: 39,
      text: 'Keep your legs straight out in front!',
    },
    {
      time: 41,
      text: 'Hold your L-sit, almost there!',
    },
    {
      time: 43,
      text: 'Keep going, you are doing great!',
    },
    {
      time: 45,
      text: 'Hold your position, finish strong!',
    },
    {
      time: 47,
      text: 'Great job! Take a break and rest.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 50,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 53,
      text: 'Shake out your arms and legs.',
    },
    {
      time: 56,
      text: 'Get ready for round two!',
    },
    {
      time: 59,
      text: 'You are building incredible strength!',
    },
    {
      time: 62,
      text: 'Ready for set two?',
    },
    {
      time: 65,
      text: '3, 2, 1, START!',
    },
    // SET 2 - 45 seconds
    {
      time: 68,
      text: 'Lift your body up with your arms again!',
    },
    {
      time: 70,
      text: 'Hold your legs straight out in front of you!',
    },
    {
      time: 72,
      text: 'Keep your core engaged and stay strong!',
    },
    {
      time: 74,
      text: 'Push through your arms, you are doing great!',
    },
    {
      time: 76,
      text: 'Hold your L-sit position, keep breathing!',
    },
    {
      time: 78,
      text: 'Keep your legs straight and your body lifted!',
    },
    {
      time: 80,
      text: 'You are building incredible arm strength!',
    },
    {
      time: 82,
      text: 'Hold your position, stay focused!',
    },
    {
      time: 84,
      text: 'Keep your core tight and your legs straight!',
    },
    {
      time: 86,
      text: 'You are doing amazing, keep going!',
    },
    {
      time: 88,
      text: 'Hold your L-sit, you are getting stronger!',
    },
    {
      time: 90,
      text: 'Keep pushing through your arms!',
    },
    {
      time: 92,
      text: 'Stay in position, you are incredible!',
    },
    {
      time: 94,
      text: 'Keep your legs straight out in front!',
    },
    {
      time: 96,
      text: 'Hold your L-sit, almost there!',
    },
    {
      time: 98,
      text: 'Keep going, you are doing great!',
    },
    {
      time: 100,
      text: 'Hold your position, finish strong!',
    },
    {
      time: 102,
      text: 'Great job! Take another break.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 105,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 108,
      text: 'Shake out your arms and legs.',
    },
    {
      time: 111,
      text: 'Get ready for round three!',
    },
    {
      time: 114,
      text: 'You are building incredible strength!',
    },
    {
      time: 117,
      text: 'Ready for set three?',
    },
    {
      time: 120,
      text: '3, 2, 1, START!',
    },
    // SET 3 - 45 seconds
    {
      time: 123,
      text: 'Lift your body up with your arms again!',
    },
    {
      time: 125,
      text: 'Hold your legs straight out in front of you!',
    },
    {
      time: 127,
      text: 'Keep your core engaged and stay strong!',
    },
    {
      time: 129,
      text: 'Push through your arms, you are doing great!',
    },
    {
      time: 131,
      text: 'Hold your L-sit position, keep breathing!',
    },
    {
      time: 133,
      text: 'Keep your legs straight and your body lifted!',
    },
    {
      time: 135,
      text: 'You are building incredible arm strength!',
    },
    {
      time: 137,
      text: 'Hold your position, stay focused!',
    },
    {
      time: 139,
      text: 'Keep your core tight and your legs straight!',
    },
    {
      time: 141,
      text: 'You are doing amazing, keep going!',
    },
    {
      time: 143,
      text: 'Hold your L-sit, you are getting stronger!',
    },
    {
      time: 145,
      text: 'Keep pushing through your arms!',
    },
    {
      time: 147,
      text: 'Stay in position, you are incredible!',
    },
    {
      time: 149,
      text: 'Keep your legs straight out in front!',
    },
    {
      time: 151,
      text: 'Hold your L-sit, almost there!',
    },
    {
      time: 153,
      text: 'Keep going, you are doing great!',
    },
    {
      time: 155,
      text: 'Hold your position, finish strong!',
    },
    {
      time: 157,
      text: 'Great job! Take another break.',
    },
    // REST PERIOD 3 - 20 seconds
    {
      time: 160,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 163,
      text: 'Shake out your arms and legs.',
    },
    {
      time: 166,
      text: 'Get ready for the final round!',
    },
    {
      time: 169,
      text: 'You are building incredible strength!',
    },
    {
      time: 172,
      text: 'Ready for the final set?',
    },
    {
      time: 175,
      text: '3, 2, 1, START!',
    },
    // SET 4 - 45 seconds
    {
      time: 178,
      text: 'Lift your body up with your arms one more time!',
    },
    {
      time: 180,
      text: 'Hold your legs straight out in front of you!',
    },
    {
      time: 182,
      text: 'Keep your core engaged and stay strong!',
    },
    {
      time: 184,
      text: 'Push through your arms, you are doing great!',
    },
    {
      time: 186,
      text: 'Hold your L-sit position, keep breathing!',
    },
    {
      time: 188,
      text: 'Keep your legs straight and your body lifted!',
    },
    {
      time: 190,
      text: 'You are building incredible arm strength!',
    },
    {
      time: 192,
      text: 'Hold your position, stay focused!',
    },
    {
      time: 194,
      text: 'Keep your core tight and your legs straight!',
    },
    {
      time: 196,
      text: 'You are doing amazing, keep going!',
    },
    {
      time: 198,
      text: 'Hold your L-sit, you are getting stronger!',
    },
    {
      time: 200,
      text: 'Keep pushing through your arms!',
    },
    {
      time: 202,
      text: 'Stay in position, you are incredible!',
    },
    {
      time: 204,
      text: 'Keep your legs straight out in front!',
    },
    {
      time: 206,
      text: 'Hold your L-sit, almost there!',
    },
    {
      time: 208,
      text: 'Keep going, you are doing great!',
    },
    {
      time: 210,
      text: 'Hold your position, finish incredibly strong!',
    },
    {
      time: 212,
      text: 'Incredible work! You are done!',
    },
    // COMPLETION
    {
      time: 215,
      text: 'Amazing work! You just held 4 L-sit positions!',
    },
    {
      time: 218,
      text: 'You are building incredible core and arm strength!',
    },
    {
      time: 221,
      text: 'Great job, strength champion!',
    },
  ],
};
